
































import {
  NONE_SUB_CATEGORY,
  PARTIAL_SUB_CATEGORY
} from '../../store/modules/transcriptTags'

export default {
  props: {
    initialOption: {
      type: String,
      required: true
    },
    listOptions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      options: this.listOptions,
      selectedOption: ''
    }
  },
  created() {
    // Prepend 'None' and 'Partial' to the options array if it's not already present
    if (!this.listOptions.includes(NONE_SUB_CATEGORY)) {
      this.options = [
        NONE_SUB_CATEGORY,
        PARTIAL_SUB_CATEGORY,
        ...this.listOptions
      ]
    } else {
      this.options = [...this.listOptions]
    }
    this.selectedOption = this.initialOption || NONE_SUB_CATEGORY
  },
  mounted() {
    window.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    handleOutsideClick(e) {
      if (!this.$refs.popup.contains(e.target)) {
        this.$emit('close')
      }
    },
    handleSave() {
      /// Emit close event with data
      this.$emit('close', {
        selectedOption: this.selectedOption
      })
    }
  }
}
